import { FSA } from 'flux-standard-action';
import { ConfigurationPanelsActionTypes } from './configuration-panels.action';

export interface ConfigurationPanelsState {
  isActive: boolean;
}

export const configurationPanelsInitialState: ConfigurationPanelsState = {
  isActive: true,
};

export const configurationPanelsReducer = (state: ConfigurationPanelsState = configurationPanelsInitialState, action: FSA<ConfigurationPanelsActionTypes, boolean>): ConfigurationPanelsState => {
  switch (action.type) {
    case ConfigurationPanelsActionTypes.Toggle:
      return {
        isActive: !state.isActive
      };
    case ConfigurationPanelsActionTypes.Hide:
      return {
        isActive: false
      };
    case ConfigurationPanelsActionTypes.Show:
      return {
        isActive: true
      };
    default:
      return state;
  }
};